import React, { useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player/lib';
import styled from 'styled-components';

const VideoPlayerWrapper = styled.div`
	height: calc(100vw / ${props => props.aspectRatio});
	max-height: 410px;
	background: #000000;

	@media ${props => props.theme.device.lgDesktop} {
		height: ${props => (props.width / 16) * 9}px;
	}

	@media ${props => props.theme.device.desktop} {
		height: 410px;
	}

	@media ${props => props.theme.device.tablet} {
		height: ${props => (props.width / 16) * 9}px;
	}
`;

interface IVideoPlayer {
	link: string;
	aspectRatio: number;
}

const VideoPlayer = ({ link, aspectRatio }: IVideoPlayer): JSX.Element => {
	const videoPlayerRef = useRef(null);
	const [wrapperSize, setWrapperSize] = useState({
		width: 0,
		height: 0,
	});

	const handleResize = () => {
		const width = videoPlayerRef.current.clientWidth;
		const height = videoPlayerRef.current.clientHeight;

		setWrapperSize({
			width, height,
		});
	};

	useEffect(() => {
		handleResize();
		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	return (
		<VideoPlayerWrapper
			ref={videoPlayerRef}
			aspectRatio={aspectRatio}
			width={wrapperSize.width}
		>
			{/* Add key for forced re-rendering for fixing video url not change bug. */}
			<ReactPlayer
				key={link}
				url={link}
				controls
				width="100%"
				height="100%"
				config={{
					file: { attributes: { controlsList: 'nodownload' } },
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					// @ts-ignore
					clientId: '44503cca1be605b5', // 測試用，網路上找的 https://codepen.io/amalajith/pen/pYmYOW
					playerId: 'youkuplayer',
				}}
			/>
		</VideoPlayerWrapper>
	);
};

export default VideoPlayer;
